import { useGetStudentGradesQuery } from "../chartsApiSlice"
import StudentBarChart from "./StudentBarChart"
import { useParams } from "react-router-dom"
const StudentChart = () => {
const { data, error, isLoading, isError } = useGetStudentGradesQuery()
const {groupId} = useParams()
if (isLoading) return <div>Loading...</div>
  if (isError) return <div>Error: {error}</div>
  const groups = groupId==="0"? data : data.filter((group) => group._id === groupId)
 
  return (
    <div>
      <h2>גרפים משימות</h2>
      <p className="par">לתשומת ליבך הציונים אינם משקללים את משקל המשימה - אלא רק אינדיקציה על הציון בעצמו</p>
      {groups && groups.map((group, index) => {
        return (
          <div key={index}>
            <StudentBarChart group={group} />
          </div>
        )
      })}
    </div>
  )
}

export default StudentChart